<div class="modal-content">
  <div class="modal-header">
    <button type="button" class="close pull-right" aria-label="Close" (click)="handleClick({ close: true })">
      <i class="fas fa-times"></i>
    </button>
    <p *ngIf="type === 'create'" class="modal-title h4" jhiTranslate="modals.addOrUpdateMerchandise.titleCreate"></p>
    <p *ngIf="type === 'update'" class="modal-title h4" jhiTranslate="modals.addOrUpdateMerchandise.titleUpdate"></p>
  </div>

  <form>
    <div class="modal-body text-left" *ngIf="controls">
      <div class="alert alert-info" jhiTranslate="modals.addOrUpdateMerchandise.alert"></div>
      <div class="col-12">
        <jhi-bary-title titleKey="modals.addOrUpdateMerchandise.subTitle"></jhi-bary-title>
      </div>
      <div class="col-12">
        <jhi-bary-input-text [control]="controls.newName" [label]="'modals.addOrUpdateMerchandise.name' | translate"></jhi-bary-input-text>
      </div>
      <div class="col-12">
        <jhi-bary-input-switch [onLabel]="'sur devis'" *ngIf="controls.forceQuotation.value" (onChangeEvent)="changeActif($event)" [value]="true"></jhi-bary-input-switch>
        <jhi-bary-input-switch [onLabel]="'sur devis'" *ngIf="!controls.forceQuotation.value" (onChangeEvent)="changeActif($event)" [value]="false"></jhi-bary-input-switch>
      </div>
      <div class="col-12 mt-4">
        <jhi-bary-input-multi-select
          [tooltip]="'modals.addOrUpdateMerchandise.offerTooltip' | translate"
          [placeholder]="'modals.addOrUpdateMerchandise.offerPlaceholder' | translate"
          [label]="'modals.addOrUpdateMerchandise.offerLabel' | translate"
          [title]="'modals.addOrUpdateMerchandise.offerTitle' | translate"
          [control]="controls.offers"
          [options]="options"
        ></jhi-bary-input-multi-select>
      </div>
    </div>

    <!--Footer-->
    <div class="modal-footer justify-content-end">
      <div class="mr-3">
        <jhi-bary-button
          [outline]="true"
          color="primary"
          [label]="'modals.addOrUpdateMerchandise.buttons.first' | translate"
          (clickEvent)="handleClick({ first: true })"
        ></jhi-bary-button>
      </div>
      <jhi-bary-button (clickEvent)="handleSubmit()" [label]="'modals.addOrUpdateMerchandise.buttons.' + type | translate" color="primary"></jhi-bary-button>
    </div>
  </form>
</div>
